import { AppRoutes } from 'config';
import { useNavigate } from 'hooks';
import { Flex } from 'components/flex';
import { Button } from 'components/button';

import * as Styles from './styles';

// TIME OFF (owner 24 Oct 2026; plan §5): approvers see how many requests
// wait, even without the Notifications feature (Admin Reps). The button opens
// the Time off page in the left menu.
export function TimeOffWaitingCard({
  count,
  close,
}: {
  count: number;
  close: () => void;
}) {
  const navigate = useNavigate();
  return (
    <div
      data-testid="time-off-waiting-card"
      style={{ padding: 16, borderBottom: '1px solid #e8e8e8' }}
    >
      <Flex column gap={8}>
        <Styles.Title>
          {count === 1
            ? '1 time-off request waiting'
            : `${count} time-off requests waiting`}
        </Styles.Title>
        <Button
          text="Open Time off"
          onClick={() => {
            close();
            navigate(AppRoutes.TimeOff.Home);
          }}
        />
      </Flex>
    </div>
  );
}
